import { render, staticRenderFns } from "./VueEditorText.vue?vue&type=template&id=562a26bf"
import script from "./VueEditorText.vue?vue&type=script&lang=js"
export * from "./VueEditorText.vue?vue&type=script&lang=js"
import style0 from "./VueEditorText.vue?vue&type=style&index=0&id=562a26bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports